import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import Paper from "@material-ui/core/Paper/Paper";
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import Button from "@material-ui/core/Button/Button";
import { AdminView } from "./admin_view.component";
import { withRouter } from "react-router";
import Tooltip from "@material-ui/core/Tooltip";
import { cancelMotiveMap, requestPeriodsMap } from "../utils/cancel.constants";

String.prototype.trunc = function (n, useWordBoundary) {
  if (this.length <= n) {
    return this;
  }
  var subString = this.substr(0, n - 1);
  return (
    (useWordBoundary
      ? subString.substr(0, subString.lastIndexOf(" "))
      : subString) + "..."
  );
};

class UserRequestCardDisperse extends React.Component {
  constructor() {
    super();
    this.goTo = this.goTo.bind(this);
  }

  goTo(location) {
    this.props.history.push(location);
  }

  isNew = () => {
    if (this.isCanceled()) return false;
    if (this.isComplete()) return false;
    return !this.props.request.admin_id;
  };

  isCanceled = () => {
    return this.props.request.is_canceled;
  };

  isComplete = () => {
    if (this.isCanceled()) return false;
    const { forward_count } = this.props.request;
    if (forward_count && forward_count > 0) {
      return true;
    }
    return false;
  };

  isPending = () => {
    return (
      !this.isComplete() && !this.isCanceled() && this.props.request.admin_id
    );
  };

  render() {
    const { request } = this.props;
    const requestPeriodClass =
      request.request_period_id === 2
        ? "admission_date_mild"
        : request.request_period_id === 1
        ? "admission_date_urgent"
        : "admission_date_unknown";

    return (
      <Paper
        className={
          `disperse-card ${this.isCanceled() && "canceled"} ${
            this.isNew() && "help-card"
          }` + (this.isComplete() ? " green-background" : "")
        }
      >
        <Grid container>
          <Grid item md={8}>
            <Grid container>
              <Grid item md={2}>
                <Typography variant="body2">
                  {moment(request.created_at)
                    .subtract(1, "hours")
                    .format("YYYY-MM-DD [às] HH:mm")}
                </Typography>
              </Grid>
              <Grid item md={2}>
                <Typography variant="body2">
                  {request.proposed_price > 0 && (
                    <Tooltip title="Mensalidade Proposta">
                      <span className="signs-span">
                        <FontAwesomeIcon icon="euro-sign" />
                        {request.proposed_price}
                      </span>
                    </Tooltip>
                  )}
                </Typography>
              </Grid>
              <Grid item md={1}>
                <Grid container justify={"flex-end"}>
                  <Tooltip title={requestPeriodsMap[request.request_period_id]}>
                    <span
                      className={`establishment_flag ${requestPeriodClass}`}
                    >
                      <FontAwesomeIcon icon="clock" />
                    </span>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid item md={2}>
                <Typography variant="body2">
                  {!this.isNew() && <b>Disperso</b>}
                  {this.isNew() && <b>Novo</b>}
                </Typography>
              </Grid>

              <Grid item md={3}>
                <AdminView
                  adminId={request.admin_id}
                  label={"CF"}
                  image={true}
                />
              </Grid>
              <Grid item md={2}>
                <Typography variant="body2">
                  {!this.isNew() && (
                    <Tooltip title="Total de Dispersões">
                      <span className="signs-span">
                        <FontAwesomeIcon icon="share" />
                        {request.forward_count || 0}
                      </span>
                    </Tooltip>
                  )}
                  {!this.isNew() && (
                    <Tooltip title="Total de Respostas">
                      <span className="signs-span">
                        <FontAwesomeIcon icon="envelope" />
                        {request.response_count || 0}
                      </span>
                    </Tooltip>
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={5}>
                <Typography className="user-name" variant="body2">
                  Emissor:{" "}
                  <b>
                    {request.user_id
                      ? request.user_name
                        ? request.user_name.toLowerCase().trunc(30, true)
                        : "N/A"
                      : request.name
                      ? request.name.toLowerCase().trunc(30, true)
                      : "N/A"}
                  </b>
                </Typography>
              </Grid>

              <Grid item md={2}>
                <Typography variant="body2">
                  {this.isCanceled() && "Cancelado"}
                  {this.isComplete() && "Concluído"}
                  {this.isPending() && "Pendente"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={3} alignItems="center">
            <Typography variant="caption">
              {cancelMotiveMap[request.cancel_reason]}
            </Typography>
          </Grid>
          <Grid item md={1} className="to-open">
            <Grid container>
              <Button
                size="small"
                color="primary"
                onClick={() => this.goTo(`/user_requests/${request.id}`)}
              >
                Open
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default withRouter(UserRequestCardDisperse);
